import type { ProductHit } from '../types';

export const hasProductPersonalization = (personalization?: ProductHit['personalization'] | null): boolean => {
    if (!personalization) return false;

    return !Object.values(personalization).every(value => !value || Object.values(value).length === 0);
};
